import Vue from 'vue';
import Vuex from 'vuex';
import ScriptLoaderModule from '@/store/scriptLoaderModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    scriptLoader: ScriptLoaderModule,
  },
  state: {
    snackInfoMessage: null,
    snackErrorMessage: null,
    user: null,
    currency: null,
  },
  mutations: {
    setSnackInfoMessage: (state, value) => {
      state.snackInfoMessage = value;
    },
    setSnackErrorMessage: (state, value) => {
      state.snackErrorMessage = value;
    },
    setUserData: (state, { user, company }) => {
      state.user = user;
      state.currency = company.currencyCode || company.currency;
    },
  },
  getters: {
    user: (state) => state.user,
    currency: (state) => state.currency,
    snackInfoMessage: (state) => state.snackInfoMessage,
    snackErrorMessage: (state) => state.snackErrorMessage,
  },
  actions: {
  },
});
